import type { RefObject } from 'react'

type BotProtectionContainerProps = {
  containerName?: string
  containerRef: RefObject<HTMLDivElement | null>
}

export const BotProtectionContainer = ({
  containerName,
  containerRef,
}: BotProtectionContainerProps) => (
  <div ref={containerRef} data-bot-protection-container={containerName ?? 'default'} />
)
